// Minimal inline markdown renderer for tool output. Supports **bold** and
// _italic_ inline; line breaks preserved by emitting <br /> between lines.
// Tool outputs are server-generated, not user-echoed, so no escaping —
// but we still build React nodes (no innerHTML) for defence in depth.

import { Fragment, type ReactNode } from 'react';

const INLINE_RE = /(\*\*[^*\n]+\*\*|_[^_\n]+_)/g;

function renderInline(line: string): ReactNode[] {
  const parts = line.split(INLINE_RE);
  return parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={i}>{part.slice(2, -2)}</strong>;
    }
    if (part.startsWith('_') && part.endsWith('_')) {
      return <em key={i}>{part.slice(1, -1)}</em>;
    }
    return <Fragment key={i}>{part}</Fragment>;
  });
}

export function MarkdownText({ text }: { text: string }): ReactNode {
  const lines = text.split('\n');
  return (
    <>
      {lines.map((line, i) => (
        <Fragment key={i}>
          {renderInline(line)}
          {i < lines.length - 1 && <br />}
        </Fragment>
      ))}
    </>
  );
}
